import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import RotatingCoin from "@/components/RotatingCoin";

const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="relative border-t border-[rgba(212,175,55,0.12)] py-12"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col items-center gap-6 text-center">
        <RotatingCoin variant="small" size={48} testId="footer-coin" />
        <div className="font-heading text-sm tracking-[0.24em] uppercase text-[var(--gold-bright)]">
          {t.footer.built}
        </div>
        <p className="text-sm text-[var(--text-muted)] max-w-md">
          {t.footer.tagline}
        </p>
        <div className="text-xs text-[var(--text-muted)]">
          © {year} CLOUD GM COIN. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
